import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"
import padding from "@irati/ui/src/global/padding"

const Body = styled.div`
  flex-grow: 1;
  margin-right: 5px;
  margin-left: ${padding.tiny};
  ${minWidthMedia.tablet`
    margin-left: ${padding.base};
  `}
  max-width: 100%;
`

export default Body
